<template>
  <div class="animated fadeIn">
    <div class="card lich-bieu">
      <div class="card-body">
        <h3
          class="uppercase text-center mt-2"
          style="
            color: #0064b2;
            font-family: 'Times new roman';
            font-weight: bold;
          "
        >
          CHÀO MỪNG ĐẾN VỚI TRANG QUẢN TRỊ CHƯƠNG TRÌNH ĐĂNG KÝ, KHAI BÁO AN TOÀN COVID-19
        </h3>
        <h3
          class="uppercase text-center mt-2"
          style="
            color: #4dbd74;
            font-family: 'Times new roman';
            font-weight: bold;
            margin-bottom: 50px;
          "
        >
          MỨC ĐỘ AN TOÀN COVID HẰNG NGÀY
        </h3>
        <FunctionalCalendar
          :markedDates="markedDates"
          :is-multiple='true'
          :calendars-count='4'
          :change-month-function="true"
          :change-year-function="true"
          :date-format="'dd-mm-yyyy'"
          :hidden-elements="['leftAndRightDays']"
          ref="Calendar"
          @changedMonth="changedMonth"
          :newCurrentDate="date"
          :dayNames="dayNames"
          :monthNames="monthNames"
          @dayClicked="dayClicked"
        >
        </FunctionalCalendar>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="'THÔNG TIN KHAI BÁO NGÀY ' + mData.selectedDay.date"
      :visible.sync="mData.dialog.dayInfo"
      width="440px"
      top="60px"
      font-size="13px"
      height="auto"
      style="max-width: 100%"
    >
      <div class="card-body">
          <b-row>
            <b-col md="4">Tài khoản</b-col>
            <b-col md="8">{{mData.selectedDay.account}}</b-col>
          </b-row>
          <b-row v-if="!mData.selectedDay.status">
            <b-col md="4">Khai báo</b-col>
            <b-col md="8">Chưa khai báo</b-col>
          </b-row>
          <b-row v-if="mData.selectedDay.status">
            <b-col md="4">Loại</b-col>
            <b-col md="8">{{mData.selectedDay.type}}</b-col>
          </b-row>
          <b-row v-if="mData.selectedDay.status">
            <b-col md="4">Đạt</b-col>
            <b-col md="8">{{mData.selectedDay.count}}/{{mData.selectedDay.max}} tiêu chí</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Xếp loại</b-col>
            <b-col md="8">{{mData.selectedDay.status == 1 ? "An toàn" : mData.selectedDay.status == 2 ? "Có nguy cơ" : "Chưa đáp ứng"}}</b-col>
          </b-row>
          <b-row v-if="mData.selectedDay.status">
            <b-col md="4">Thời điểm</b-col>
            <b-col md="8">{{mData.selectedDay.time}}</b-col>
          </b-row>
          <b-row v-if="mData.selectedDay.status">
            <b-col md="4">Trạng thái dịch</b-col>
            <b-col md="8">{{mData.selectedDay.max > 10 ? "Có dịch" : "An toàn"}} <em>(tại thời điểm khai báo)</em></b-col>
          </b-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import { FunctionalCalendar } from 'vue-functional-calendar';
import DiemDenAnToanApi from '../../../moduleApi/DiemDenAnToanApi';
import MethodService from '../../../service/MethodService';
import DataService from '../../../service/DataService';
import moment from "moment";

export default {
  name: "LichBieuKBAT",
  components: {
    FunctionalCalendar
  },
  data: function () {
    let user = MethodService.getCurrentUser();
    return {
      aLang: LanguageService.lang,
      mData: {
        selectedDay: {
          date: "",
          account: user ? user.account : "",
          status: "",
          type: "",
          count: 0,
          max: 0,
          time: ""
        },
        dialog: {
          dayInfo: false
        }
      },
      ddat: null,
      markedDates: [],
      calendarConfigs: {
        hiddenElements:['leftAndRightDays'],
      },
      date: null,
      dayNames: ["T2","T3","T4","T5","T6","T7","CN"],
      monthNames: ["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"]
    };
  },
  created() {
    let dt = new Date();
    dt.setHours(0,0,0,0);
    dt.setDate(1);
    dt.setMonth(dt.getMonth() - 3);
    this.date = dt;
    this.getDeclaredStatusCalendar(dt);
  },
  methods: {
    async getDeclaredStatusCalendar(startDate) {
      try {
        let user = MethodService.getCurrentUser();
        let dateRange = this.getDateRange(startDate);

        if (!this.ddat) {
          let ddats = await DiemDenAnToanApi.list({
            filters: ["nguoi_tao_id=$$user_id"],
            fields: "id,loai_diem_den,nguoi_tao_id,thoi_diem_tao",
            limit: 1
          });
          if (ddats.result.length) {
            this.ddat = ddats.result[0];
          }
        }

        let createdTime = 0;
        if (this.ddat && this.ddat.thoi_diem_tao) {
          let d = new Date(this.ddat.thoi_diem_tao);
          d.setMilliseconds(0);
          d.setSeconds(0);
          d.setMinutes(0);
          d.setHours(0);
          createdTime = d.getTime();
        }
        let day = Math.max(new Date(2020, 10, 9, 0, 0).getTime(), createdTime);

        const declaredStatusCalender = new Date(dateRange.to).getTime() < day || new Date(dateRange.from).getTime() > new Date().getTime()
          ? {code: 0, result: []} 
          : await DiemDenAnToanApi.declaredStatusCalendar({
            dd_account: user.account,
            from: dateRange.from,
            to: dateRange.to,
          });
        this.processMarkedDate(dateRange, declaredStatusCalender.result);
      } catch (error) {
        console.log('error', error)
      }
    },
    getFormatedDate(date) {
      let d = new Date(date);
      let dd = d.getDate();
      let mm = d.getMonth() + 1;
      let y = d.getFullYear();

      return dd + "-" + mm + "-" + y;
    },
    getDateRange(startDate) {
      let d = new Date(startDate);
      //let fromDate = moment(d).format("YYYY-MM-DDTHH:mm:ssZ");
      let fromDate = d.toISOString();
      d.setMonth(d.getMonth() + 4);
      //let toDate = moment(d).format("YYYY-MM-DDTHH:mm:ssZ");
      let toDate = d.toISOString();
      return  { from: fromDate, to: toDate };
    },
    processMarkedDate(today, declaredCalendar) {
      let createdTime = 0;
      if (this.ddat && this.ddat.thoi_diem_tao) {
        let d = new Date(this.ddat.thoi_diem_tao);
        d.setMilliseconds(0);
        d.setSeconds(0);
        d.setMinutes(0);
        d.setHours(0);
        createdTime = d.getTime();
      }
      let day = Math.max(new Date(2020, 10, 9, 0, 0).getTime(), new Date(today.from).getTime(), createdTime);
      let to = Math.min(new Date().getTime(), new Date(today.to).getTime());
      declaredCalendar.forEach(item => item._time = new Date(item.date).getTime());
      while (day <= to)
      {
        let dateItem = declaredCalendar.find(item => item._time == day);
        let className = "not-safe not-declared";
        if (dateItem) {
          switch (dateItem.status) {
            case 1: 
              className = "safe";
              break;
            case 2: 
              className = "risky";
              break;
            case 3: 
              className = "not-safe";
              break;
          }
        }

        let date = this.getFormatedDate(day);
        var markedDateItem = this.markedDates.find(item => item.date == date);
        if (markedDateItem) {
          markedDateItem.class = className;
        } 
        else {
          this.markedDates.push({
            date: date,
            item: dateItem,
            class: className
          });
        }
        
        day += 24 * 60 * 60 * 1000;
      }
    },
    changedMonth(date) {
      this.getDeclaredStatusCalendar(date);
    },
    dayClicked(date) {
      let selectedDay = this.markedDates.find(item => item.date == date.date);
      if (!selectedDay) return;
      console.log("selectedDay", selectedDay);
      if (selectedDay.item) {
        console.log("selectedDay.item.time", selectedDay.item.time)
        let time = moment(selectedDay.item.time);
        this.mData.selectedDay.date = time.format("DD-MM-YYYY");
        this.mData.selectedDay.time = time.format("HH:mm");
        this.mData.selectedDay.status = selectedDay.item.status;
        this.mData.selectedDay.count = selectedDay.item.count;
        this.mData.selectedDay.max = selectedDay.item.max;
        let loaiHinh = DataService.loaiHinhRegister.find(lh => lh.code == selectedDay.item.type);
        this.mData.selectedDay.type = loaiHinh ? loaiHinh.text : selectedDay.item.type;
      }
      else {
        let time = moment(selectedDay.date, "D-M-YYYY");
        this.mData.selectedDay.date = time.format("DD-MM-YYYY");
        this.mData.selectedDay.time = "";
        this.mData.selectedDay.status = null;
        this.mData.selectedDay.count = "";
        this.mData.selectedDay.max = "";
        this.mData.selectedDay.type = "";
      }

      this.mData.dialog.dayInfo = true;
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss">
.lich-bieu {
  .fade-enter-active {
    transition: all 0.3s ease;
  }
  .fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .fade-enter,
  .fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
  .card-body {
    min-height: 86vh;
  }
  &.card {
    position: relative;
  }

  &.card::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 90%;
    height: 90%;
    background-image: url("~/img/safe-travel.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    opacity: 0.3;
    transform: translate(-50%,-50%);
  }

  .vfc-main-container {
    background-color: rgba(255,255,255,0.9);
  }

  .vfc-success {
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #09ff00;
    bottom: 3px;
    left: calc(50% - 15px);
  }

  .vfc-underline {
    -webkit-text-decoration: none!important;
    text-decoration: none!important;
  }

  .vfc-content {
    z-index: 1!important;
  }

  .vfc-week {
    .vfc-day {
      span.vfc-span-day {
        // background-color: #09ff00;

        &.vfc-today {
          width: 30px;
          line-height: 30px;
          color: #ffffff;
          background-color: #007BFF;
          border-radius: 100%;
          margin: 0 auto;
        }

        &.not-safe {
          background-color: #ff0404;
          color: #ffffff;
          cursor: pointer;

          &.not-declared {
            color: #ddd;
          }
        }

        &.risky {
          background-color: #f7e438;
          color: #ffffff;
          cursor: pointer;
        }

        &.safe {
          background-color: #4dbd74;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
